import Utils from "../Shared/Utils"
import * as CryptoJS from "../Lib/crypto-js"
import ImageCache from "../Shared/ImageCache";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ThirdGameItem extends cc.Component {
    @property(cc.Node)
    nodeDefaultImage: cc.Node = null

    @property(cc.Node)
    nodeMaintenance: cc.Node = null

    @property(cc.Label)
    lbName: cc.Label = null

    @property(cc.Sprite)
    spUrlImage: cc.Sprite = null

    urlImgPrefix: string = ""
    
    private _gameConfig: Object = null

    set gameConfig (value) {
        this.nodeDefaultImage.active = false
        this._gameConfig = value
        this.lbName.string = this._gameConfig["gameTitleCn"]

        if (!this._gameConfig["gameStatus"] || this._gameConfig["gameStatus"] === "0") {
            this.nodeMaintenance.active = false
            this.nodeDefaultImage.color = cc.color(255, 255, 255)
            this.spUrlImage.node.color = cc.color(255, 255, 255)
            this.lbName.node.color = cc.color(255, 255, 255)
        }else {
            this.nodeMaintenance.active = true
            this.nodeDefaultImage.color = cc.color(111, 111, 111)
            this.spUrlImage.node.color = cc.color(111, 111, 111)
            this.lbName.node.color = cc.color(111, 111, 111)
        }

        if (this._gameConfig["gameImageUrl1"]) {
            if (cc.sys.isNative) {
                ImageCache.loadImage(this.urlImgPrefix + this._gameConfig["gameImageUrl1"], function (err, texture) {
                    if (!err && this.node && this._gameConfig && texture.url === ImageCache.getCachePath(this.urlImgPrefix + this._gameConfig["gameImageUrl1"])) {
                        this.showTexture(texture)
                    }
                }.bind(this))
            }else {
                cc.loader.load({url: this.urlImgPrefix + this._gameConfig["gameImageUrl1"], type: "png"}, function (err, texture) {
                    if (!err && this.node && this._gameConfig && texture.url === this.urlImgPrefix + this._gameConfig["gameImageUrl1"]) {
                        this.showTexture(texture)
                    }
                }.bind(this))    
            }

            // 一段时间网图还没加载出来，就显示占位图
            this.scheduleOnce(function () {
                if (!this.spUrlImage.spriteFrame) {
                    this.nodeDefaultImage.active = true
                }
            }.bind(this), 0.2)
        }else {
            this.spUrlImage.spriteFrame = null
            this.nodeDefaultImage.active = true
        }
    }

    get gameConfig () {
        return this._gameConfig
    }

    // 重写方法
    reuse () {
        this.nodeDefaultImage.active = false
    }

    // 重写方法
    unuse () {
        this.spUrlImage.spriteFrame = null
        this.urlImgPrefix = ""
        this._gameConfig = null
        this.node.active = true
        this.node.position = cc.v2(0, 0)
    }

    private showTexture (texture) {
        this.spUrlImage.spriteFrame = new cc.SpriteFrame(texture)
        this.nodeDefaultImage.active = false
    }
}